import { Browser } from "@capacitor/browser";

// Shared browser state to prevent "No active window to close" errors across the app
class BrowserState {
  private isOpen = false;

  constructor() {
    // Add browser event listeners to automatically track state
    this.setupEventListeners();
  }

  private setupEventListeners(): void {
    // Listen for browser finished event to automatically mark as closed
    void Browser.addListener("browserFinished", () => {
      this.setOpen(false);
    });

    // Listen for browser page loaded event to confirm it's open
    void Browser.addListener("browserPageLoaded", () => {
      this.setOpen(true);
    });
  }

  setOpen(open: boolean): void {
    this.isOpen = open;
  }

  getIsOpen(): boolean {
    return this.isOpen;
  }
}

export const browserState = new BrowserState();
